import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useReferenceData } from '../../../hooks/use_reference_data';
import { getSpeciesBySpeciesName } from '../../../redux/reference_data';

export const useSpeciesSeasonGroupFilters = () => {
  const [filterSpeciesName, setFilterSpeciesName] = useState<string | null>(null);
  const speciesBySpeciesName = useSelector(getSpeciesBySpeciesName);
  const filterSpecies = speciesBySpeciesName(filterSpeciesName);

  const [filterSeasonGroupName, setFilterSeasonGroupName] = useState<string | null>(null);
  const { allSeasonGroups } = useReferenceData();
  const filterSeasonGroup = allSeasonGroups.find((sg) => sg.name === filterSeasonGroupName);

  return {
    filterSeasonGroup,
    filterSpecies,
    setFilterSeasonGroupName,
    setFilterSpeciesName,
  };
};
